export const getTitle = (title)=>{
    if (!title?.title) return undefined;
    return {
        title: title.title,
        link: title?.link,
        subTitle: title?.subTitle ?? title?.subtitle,
        icon: typeof title?.icon === 'string' ? title?.icon : title?.icon?.name
    };
};

//# sourceMappingURL=utils.js.map